const productsData = [
  //high-performance-drills
  {
    id: 1,
    slug: "micro-drills-non-through-coolant",
    category: "high-performance-drills",
    name: "Micro Drills Non Through Coolant",

    images: {
      main: "/assets/images/pristine-product/drills-product-1.png",
      thumbs: [
        "/assets/images/pristine-product/drills-product-1.png",
        "/assets/images/productpart1.png",
      ],
    },
    table: [
    {
      itemCode: "PD3 010",
      cuttingDiameter: "1",
      shankDiameter: "4",
      fluteLength: "7",
      overallLength: "54",
    },
    {
      itemCode: "PD3 01250",
      cuttingDiameter: "1.25",
      shankDiameter: "4",
      fluteLength: "7",
      overallLength: "54",
    },
    {
      itemCode: "PD3 0150",
      cuttingDiameter: "1.5",
      shankDiameter: "4",
      fluteLength: "9",
      overallLength: "54",
    },
    {
      itemCode: "PD3 01750",
      cuttingDiameter: "1.75",
      shankDiameter: "4",
      fluteLength: "9",
      overallLength: "54",
    },
    {
      itemCode: "PD3 020",
      cuttingDiameter: "2",
      shankDiameter: "4",
      fluteLength: "9",
      overallLength: "54",
    },
    {
      itemCode: "PD3 02250",
      cuttingDiameter: "2.25",
      shankDiameter: "4",
      fluteLength: "12",
      overallLength: "54",
    },
    {
      itemCode: "PD3 0250",
      cuttingDiameter: "2.5",
      shankDiameter: "4",
      fluteLength: "12",
      overallLength: "54",
    },
    {
      itemCode: "PD3 02750",
      cuttingDiameter: "2.75",
      shankDiameter: "4",
      fluteLength: "12",
      overallLength: "54",
    },
    {
      itemCode: "PD3 030",
      cuttingDiameter: "3",
      shankDiameter: "4",
      fluteLength: "12",
      overallLength: "54",
    },
  ],
  },

  {
    id: 2,
    slug: "standard-drills-non-through-coolant",
    category: "high-performance-drills",
    name: "standard Drills Non Through Coolant",
    images: {
      main: "/assets/images/pristine-product/drills.png",
      thumbs: [
        "/assets/images/pristine-product/drills.png",
        "/assets/images/productpart1.png",
      ],
    },
    tableGroups: [
      {
        title: "DRILL LxD-3",
        tables: [
          {
            headers: [
              "ITEM CODE",
              "CUTTING DIA.",
              "SHANK DIA.",
              "FLUTE LENGTH",
              "OVER ALL LENGTH",
            ],
            rows: [
              {
                itemCode: "PD3 0304",
                millDia: "3.00 - 4.00",
                shankDia: "6",
                flute: "25",
                oal: "63",
              },
              {
                itemCode: "PD3 0405",
                millDia: "4.01 - 5.00",
                shankDia: "6",
                flute: "25",
                oal: "63",
              },
              {
                itemCode: "PD3 0506",
                millDia: "5.01 - 6.00",
                shankDia: "6",
                flute: "35",
                oal: "76",
              },
              {
                itemCode: "PD3 0608",
                millDia: "6.01 - 8.00",
                shankDia: "8",
                flute: "35",
                oal: "79",
              },
              {
                itemCode: "PD3 0810",
                millDia: "8.01 - 10.00",
                shankDia: "10",
                flute: "45",
                oal: "89",
              },
              {
                itemCode: "PD3 1012",
                millDia: "10.01 - 12.00",
                shankDia: "12",
                flute: "55",
                oal: "100",
              },
              {
                itemCode: "PD3 1214",
                millDia: "12.01 - 14.00",
                shankDia: "14",
                flute: "60",
                oal: "110",
              },
              {
                itemCode: "PD3 1416",
                millDia: "14.01 - 16.00",
                shankDia: "16",
                flute: "65",
                oal: "115",
              },
              {
                itemCode: "PD3 1618",
                millDia: "16.01 - 18.00",
                shankDia: "18",
                flute: "73",
                oal: "123",
              },
              {
                itemCode: "PD3 1820",
                millDia: "18.01 - 20.00",
                shankDia: "20",
                flute: "79",
                oal: "131",
              },
            ],
          },
        ],
      },

      {
        title: "DRILL LxD-5",
        tables: [
          {
            headers: [
              "ITEM CODE",
              "CUTTING DIA.",
              "SHANK DIA.",
              "FLUTE LENGTH",
              "OVER ALL LENGTH",
            ],
            rows: [
              {
                itemCode: "PD5 0304",
                millDia: "3.00 - 4.00",
                shankDia: "6",
                flute: "35",
                oal: "74",
              },
              {
                itemCode: "PD5 0405",
                millDia: "4.01 - 5.00",
                shankDia: "6",
                flute: "40",
                oal: "80",
              },
              {
                itemCode: "PD5 0506",
                millDia: "5.01 - 6.00",
                shankDia: "6",
                flute: "45",
                oal: "82",
              },
              {
                itemCode: "PD5 0608",
                millDia: "6.01 - 8.00",
                shankDia: "8",
                flute: "50",
                oal: "91",
              },
              {
                itemCode: "PD5 0810",
                millDia: "8.01 - 10.00",
                shankDia: "10",
                flute: "55",
                oal: "103",
              },
              {
                itemCode: "PD5 1012",
                millDia: "10.01 - 12.00",
                shankDia: "12",
                flute: "75",
                oal: "120",
              },
              {
                itemCode: "PD5 1214",
                millDia: "12.01 - 14.00",
                shankDia: "14",
                flute: "80",
                oal: "125",
              },
              {
                itemCode: "PD5 1416",
                millDia: "14.01 - 16.00",
                shankDia: "16",
                flute: "85",
                oal: "135",
              },
              {
                itemCode: "PD5 1618",
                millDia: "16.01 - 18.00",
                shankDia: "18",
                flute: "93",
                oal: "143",
              },
              {
                itemCode: "PD5 1820",
                millDia: "18.01 - 20.00",
                shankDia: "20",
                flute: "101",
                oal: "153",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 3,
    slug: "standard-drills-through-coolant",
    category: "high-performance-drills",
    name: "Standard Drills Through Coolant",
    images: {
      main: "/assets/images/pristine-product/drills.png",
      thumbs: [
        "/assets/images/pristine-product/drills.png",
        "/assets/images/productpart1.png",
      ],
    },
    tableGroups: [
      {
        title: "Through Coolant Drill LxD3",
        tables: [
          {
            headers: [
              "ITEM CODE",
              "CUTTING DIA.",
              "SHANK DIA.",
              "FLUTE LENGTH",
              "OVER ALL LENGTH",
            ],
            rows: [
              {
                itemCode: "PD3 0304 TC",
                millDia: "3.00 - 4.00",
                shankDia: "6",
                flute: "25",
                oal: "63",
              },
              {
                itemCode: "PD3 0405 TC",
                millDia: "4.01 - 5.00",
                shankDia: "6",
                flute: "25",
                oal: "63",
              },
              {
                itemCode: "PD3 0506 TC",
                millDia: "5.01 - 6.00",
                shankDia: "6",
                flute: "35",
                oal: "76",
              },
              {
                itemCode: "PD3 0608 TC",
                millDia: "6.01 - 8.00",
                shankDia: "8",
                flute: "35",
                oal: "79",
              },
              {
                itemCode: "PD3 0810 TC",
                millDia: "8.01 - 10.00",
                shankDia: "10",
                flute: "45",
                oal: "89",
              },
              {
                itemCode: "PD3 1012 TC",
                millDia: "10.01 - 12.00",
                shankDia: "12",
                flute: "55",
                oal: "100",
              },
              {
                itemCode: "PD3 1214 TC",
                millDia: "12.01 - 14.00",
                shankDia: "14",
                flute: "60",
                oal: "110",
              },
              {
                itemCode: "PD3 1416 TC",
                millDia: "14.01 - 16.00",
                shankDia: "16",
                flute: "65",
                oal: "115",
              },
              {
                itemCode: "PD3 1618 TC",
                millDia: "16.01 - 18.00",
                shankDia: "18",
                flute: "73",
                oal: "123",
              },
              {
                itemCode: "PD3 1820 TC",
                millDia: "18.01 - 20.00",
                shankDia: "20",
                flute: "79",
                oal: "131",
              },
            ],
          },
        ],
      },

      {
        title: "Through Coolant Drill LxD5",
        tables: [
          {
            headers: [
              "ITEM CODE",
              "CUTTING DIA.",
              "SHANK DIA.",
              "FLUTE LENGTH",
              "OVER ALL LENGTH",
            ],
            rows: [
              {
                itemCode: "PD5 0304 TC",
                millDia: "3.00 - 4.00",
                shankDia: "6",
                flute: "35",
                oal: "74",
              },
              {
                itemCode: "PD5 0405 TC",
                millDia: "4.01 - 5.00",
                shankDia: "6",
                flute: "40",
                oal: "80",
              },
              {
                itemCode: "PD5 0506 TC",
                millDia: "5.01 - 6.00",
                shankDia: "6",
                flute: "45",
                oal: "82",
              },
              {
                itemCode: "PD5 0608 TC",
                millDia: "6.01 - 8.00",
                shankDia: "8",
                flute: "50",
                oal: "91",
              },
              {
                itemCode: "PD5 0810 TC",
                millDia: "8.01 - 10.00",
                shankDia: "10",
                flute: "55",
                oal: "103",
              },
              {
                itemCode: "PD5 1012 TC",
                millDia: "10.01 - 12.00",
                shankDia: "12",
                flute: "75",
                oal: "120",
              },
              {
                itemCode: "PD5 1214 TC",
                millDia: "12.01 - 14.00",
                shankDia: "14",
                flute: "80",
                oal: "125",
              },
              {
                itemCode: "PD5 1416 TC",
                millDia: "14.01 - 16.00",
                shankDia: "16",
                flute: "85",
                oal: "135",
              },
              {
                itemCode: "PD5 1618 TC",
                millDia: "16.01 - 18.00",
                shankDia: "18",
                flute: "93",
                oal: "143",
              },
              {
                itemCode: "PD5 1820 TC",
                millDia: "18.01 - 20.00",
                shankDia: "20",
                flute: "101",
                oal: "153",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 4,
    slug: "center-drills",
    category: "high-performance-drills",
    name: "Center-Drills",
    images: {
      main: "/assets/images/pristine-product/Center_Drill.png",
      thumbs: [
        "/assets/images/pristine-product/Center_Drill.png",
        "/assets/images//pristine-product/center_drill_wire.png",
      ],
    },
    tableGroups: [
      {
        title: "Center Drill Metric",
        tables: [
          {
            headers: [
              "ITEM CODE",  
              "PILOT DIA (D)",
              "BODY DIA (d)",
              "CEL (l)",
              "OAL (L)",
            ],
            rows: [
              {
                itemCode: "PCDM 3.15",
                 millDia: "3.15",
                shankDia: "8",
                flute: "4.4",
                oal: "50",
              },
              {
                itemCode: "PCDM 4",
                 millDia: "4",
                shankDia: "10",
                flute: "5.6",
                oal: "56",
              },
              {
                itemCode: "PCDM 5",
                 millDia: "5",
                shankDia: "12.5",
                flute: "6.9",
                oal: "63",
              },
              {
                itemCode: "PCDM 6.3",
                 millDia: "6.3",
                shankDia: "16",
                flute: "8.6",
                oal: "71",
              },
            ],
          },
        ],
      },

      {
        title: "Center Drill Inch",
        tables: [
          {
            headers: [
              "ITEM CODE",
              "PILOT DIA (D)",
              "BODY DIA (d)",
              "CEL (l)",
              "OAL (L)",
            ],
            rows: [
              {
                itemCode: 'PCDI 1/8"',
                 millDia: '1/8"',
                shankDia: '5/16"',
                flute: '3/16"',
                oal: '2-1/4"',
              },
              {
                itemCode: 'PCDI 3/16"',
                 millDia: '3/16"',
                shankDia: '7/16"',
                flute: '9/32"',
                oal: '2-1/2"',
              },
              {
                itemCode: 'PCDI 1/4"',
                 millDia: '1/4"',
                shankDia: '5/8"',
                flute: '3/8"',
                oal: '3"',
              },
            ],
          },
        ],
      },
    ],
  },
  //High-performance-endmills
  {
    id: 5,
    slug: "long-endmills",
    category: "High-performance-endmills",
    name: "Long Endmills",

    images: {
      main: "/assets/images/pristine-product/Endmills.png",
      thumbs: [
        "/assets/images/pristine-product/Endmills.png",
        "/assets/images/pristine-product/Endmill_Wire.png",
      ],
    },

    table: [
      {
        itemCode: "PB4F 03 R",
        cuttingDiameter: "3",
        shankDiameter: "3",
        fluteLength: "10",
        overallLength: "39",
      },
      {
        itemCode: "PB4F 04 R",
        cuttingDiameter: "4",
        shankDiameter: "4",
        fluteLength: "14",
        overallLength: "51",
      },
      {
        itemCode: "PB4F 05 R",
        cuttingDiameter: "5",
        shankDiameter: "5",
        fluteLength: "16",
        overallLength: "51",
      },
      {
        itemCode: "PB4F 06 R",
        cuttingDiameter: "6",
        shankDiameter: "6",
        fluteLength: "19",
        overallLength: "63",
      },
      {
        itemCode: "PB4F 08 R",
        cuttingDiameter: "8",
        shankDiameter: "8",
        fluteLength: "22",
        overallLength: "63",
      },
      {
        itemCode: "PB4F 10 R",
        cuttingDiameter: "10",
        shankDiameter: "10",
        fluteLength: "25",
        overallLength: "70",
      },
      {
        itemCode: "PB4F 12 R",
        cuttingDiameter: "12",
        shankDiameter: "12",
        fluteLength: "25",
        overallLength: "75",
      },
      {
        itemCode: "PB4F 14 R",
        cuttingDiameter: "14",
        shankDiameter: "14",
        fluteLength: "30",
        overallLength: "80",
      },
      {
        itemCode: "PB4F 16 R",
        cuttingDiameter: "16",
        shankDiameter: "16",
        fluteLength: "32",
        overallLength: "89",
      },
      {
        itemCode: "PB4F 18 R",
        cuttingDiameter: "18",
        shankDiameter: "18",
        fluteLength: "35",
        overallLength: "100",
      },
      {
        itemCode: "PB4F 20 R",
        cuttingDiameter: "20",
        shankDiameter: "20",
        fluteLength: "38",
        overallLength: "100",
      },
    ],
  },
  {
    id: 6,
    slug: "extra-long-endmills",
    category: "High-performance-endmills",
    name: "Extra Long Endmills",

    images: {
      main: "/assets/images/pristine-product/Endmills.png",
      thumbs: [
        "/assets/images/pristine-product/Endmills.png",
        "/assets/images/pristine-product/Endmill_Wire.png",
      ],
    },

    table: [
      {
        itemCode: "PB4F 03 R",
        cuttingDiameter: "3",
        shankDiameter: "3",
        fluteLength: "10",
        overallLength: "39",
      },
      {
        itemCode: "PB4F 04 R",
        cuttingDiameter: "4",
        shankDiameter: "4",
        fluteLength: "14",
        overallLength: "51",
      },
      {
        itemCode: "PB4F 05 R",
        cuttingDiameter: "5",
        shankDiameter: "5",
        fluteLength: "16",
        overallLength: "51",
      },
      {
        itemCode: "PB4F 06 R",
        cuttingDiameter: "6",
        shankDiameter: "6",
        fluteLength: "19",
        overallLength: "63",
      },
      {
        itemCode: "PB4F 08 R",
        cuttingDiameter: "8",
        shankDiameter: "8",
        fluteLength: "22",
        overallLength: "63",
      },
      {
        itemCode: "PB4F 10 R",
        cuttingDiameter: "10",
        shankDiameter: "10",
        fluteLength: "25",
        overallLength: "70",
      },
      {
        itemCode: "PB4F 12 R",
        cuttingDiameter: "12",
        shankDiameter: "12",
        fluteLength: "25",
        overallLength: "75",
      },
      {
        itemCode: "PB4F 14 R",
        cuttingDiameter: "14",
        shankDiameter: "14",
        fluteLength: "30",
        overallLength: "80",
      },
      {
        itemCode: "PB4F 16 R",
        cuttingDiameter: "16",
        shankDiameter: "16",
        fluteLength: "32",
        overallLength: "89",
      },
      {
        itemCode: "PB4F 18 R",
        cuttingDiameter: "18",
        shankDiameter: "18",
        fluteLength: "35",
        overallLength: "100",
      },
      {
        itemCode: "PB4F 20 R",
        cuttingDiameter: "20",
        shankDiameter: "20",
        fluteLength: "38",
        overallLength: "100",
      },
    ],
  },

  {
    id: 7,
    slug: "regular-endmills",
    category: "High-performance-endmills",
    name: "Regular Endmills",

    images: {
      main: "/assets/images/pristine-product/Endmills.png",
      thumbs: [
        "/assets/images/pristine-product/Endmills.png",
        "/assets/images/pristine-product/Endmill_Wire.png",
      ],
    },

    table: [
      {
        itemCode: "PB4F 03 R",
        cuttingDiameter: "3",
        shankDiameter: "3",
        fluteLength: "10",
        overallLength: "39",
      },
      {
        itemCode: "PB4F 04 R",
        cuttingDiameter: "4",
        shankDiameter: "4",
        fluteLength: "14",
        overallLength: "51",
      },
      {
        itemCode: "PB4F 05 R",
        cuttingDiameter: "5",
        shankDiameter: "5",
        fluteLength: "16",
        overallLength: "51",
      },
      {
        itemCode: "PB4F 06 R",
        cuttingDiameter: "6",
        shankDiameter: "6",
        fluteLength: "19",
        overallLength: "63",
      },
      {
        itemCode: "PB4F 08 R",
        cuttingDiameter: "8",
        shankDiameter: "8",
        fluteLength: "22",
        overallLength: "63",
      },
      {
        itemCode: "PB4F 10 R",
        cuttingDiameter: "10",
        shankDiameter: "10",
        fluteLength: "25",
        overallLength: "70",
      },
      {
        itemCode: "PB4F 12 R",
        cuttingDiameter: "12",
        shankDiameter: "12",
        fluteLength: "25",
        overallLength: "75",
      },
      {
        itemCode: "PB4F 14 R",
        cuttingDiameter: "14",
        shankDiameter: "14",
        fluteLength: "30",
        overallLength: "80",
      },
      {
        itemCode: "PB4F 16 R",
        cuttingDiameter: "16",
        shankDiameter: "16",
        fluteLength: "32",
        overallLength: "89",
      },
      {
        itemCode: "PB4F 18 R",
        cuttingDiameter: "18",
        shankDiameter: "18",
        fluteLength: "35",
        overallLength: "100",
      },
      {
        itemCode: "PB4F 20 R",
        cuttingDiameter: "20",
        shankDiameter: "20",
        fluteLength: "38",
        overallLength: "100",
      },
    ],
  },
  {
    id: 8,
    slug: "rougher-endmills",
    category: "High-performance-endmills",
    name: "Rougher Endmills",

    images: {
      main: "/assets/images/pristine-product/Endmills.png",
      thumbs: [
        "/assets/images/pristine-product/Endmills.png",
        "/assets/images/pristine-product/Endmill_Wire.png",
      ],
    },

    table: [
      {
        itemCode: "PRE 05S",
        cuttingDiameter: "5",
        shankDiameter: "5",
        fluteLength: "16",
        overallLength: "51",
      },
      {
        itemCode: "PRE 06S",
        cuttingDiameter: "6",
        shankDiameter: "6",
        fluteLength: "19",
        overallLength: "63",
      },
      {
        itemCode: "PRE 08S",
        cuttingDiameter: "8",
        shankDiameter: "8",
        fluteLength: "21",
        overallLength: "63",
      },
      {
        itemCode: "PRE 10S",
        cuttingDiameter: "10",
        shankDiameter: "10",
        fluteLength: "25",
        overallLength: "70",
      },
      {
        itemCode: "PRE 12S",
        cuttingDiameter: "12",
        shankDiameter: "12",
        fluteLength: "25",
        overallLength: "75",
      },
      {
        itemCode: "PRE 14S",
        cuttingDiameter: "14",
        shankDiameter: "14",
        fluteLength: "30",
        overallLength: "89",
      },
      {
        itemCode: "PRE 16S",
        cuttingDiameter: "16",
        shankDiameter: "16",
        fluteLength: "32",
        overallLength: "89",
      },
      {
        itemCode: "PRE 18S",
        cuttingDiameter: "18",
        shankDiameter: "18",
        fluteLength: "40",
        overallLength: "101",
      },
      {
        itemCode: "PRE 20S",
        cuttingDiameter: "20",
        shankDiameter: "20",
        fluteLength: "40",
        overallLength: "101",
      },
    ],
  },
  {
    id: 9,
    slug: "single-lip-endmills",
    category: "High-performance-endmills",
    name: "Single Lip Endmills",

    images: {
      main: "/assets/images/pristine-product/Single_Lip.png",
      thumbs: [
        "/assets/images/pristine-product/Single_Lip.png",
        "/assets/images/pristine-product/Single_Lip_Wire.png",
      ],
    },

    table: [
      {
        itemCode: "PSL 06",
        cuttingDiameter: "6",
        shankDiameter: "6",
        fluteLength: "10",
        overallLength: "63",
      },
      {
        itemCode: "PSL 08",
        cuttingDiameter: "8",
        shankDiameter: "8",
        fluteLength: "12",
        overallLength: "63",
      },
      {
        itemCode: "PSL 10",
        cuttingDiameter: "10",
        shankDiameter: "10",
        fluteLength: "15",
        overallLength: "70",
      },
      {
        itemCode: "PSL 12",
        cuttingDiameter: "12",
        shankDiameter: "12",
        fluteLength: "20",
        overallLength: "75",
      },
      {
        itemCode: "PSL 14",
        cuttingDiameter: "14",
        shankDiameter: "14",
        fluteLength: "20",
        overallLength: "76",
      },
      {
        itemCode: "PSL 16",
        cuttingDiameter: "16",
        shankDiameter: "16",
        fluteLength: "25",
        overallLength: "76",
      },
      {
        itemCode: "PSL 20",
        cuttingDiameter: "20",
        shankDiameter: "20",
        fluteLength: "25",
        overallLength: "100",
      },
    ],
  },
  {
    id: 10,
    slug: "taper-stub-neck-endmill",
    category: "High-performance-endmills",
    name: "Taper/Stub Neck Endmill",

    images: {
      main: "/assets/images/pristine-product/Taper & Stub nech Endmill.png",
      thumbs: [
        "/assets/images/pristine-product/Taper & Stub nech Endmill.png",
        "/assets/images/pristine-product/Taper & Stub Nech-Wire.png",
      ],
    },

    tableGroups: [
      {
        title: "Taper Neck Endmill : 2 / 4 Flutes",
        style: "taper",
        tables: [
          {
            subTitle: "Flat Endmills",
            headers: ["ITEM CODE", "MILL DIA", "SHANK DIA", "FLUTE", "OAL"],
            rows: [
              {
                itemCode: "PTNE4 03",
                millDia: "3",
                shankDia: "6",
                flute: "6",
                oal: "75",
              },
              {
                itemCode: "PTNE4 04",
                millDia: "4",
                shankDia: "6",
                flute: "8",
                oal: "75",
              },
              {
                itemCode: "PTNE4 05",
                millDia: "5",
                shankDia: "8",
                flute: "10",
                oal: "100",
              },
              {
                itemCode: "PTNE4 06",
                millDia: "6",
                shankDia: "8",
                flute: "12",
                oal: "100",
              },
              {
                itemCode: "PTNE4 08",
                millDia: "8",
                shankDia: "10",
                flute: "14",
                oal: "100",
              },
            ],
          },
          {
            subTitle: "Ballnose",
            headers: ["ITEM CODE", "MILL DIA", "SHANK DIA", "FLUTE", "OAL"],
            rows: [
              {
                itemCode: "PTNB4 03",
                millDia: "3",
                shankDia: "6",
                flute: "6",
                oal: "75",
              },
              {
                itemCode: "PTNB4 04",
                millDia: "4",
                shankDia: "6",
                flute: "8",
                oal: "75",
              },
              {
                itemCode: "PTNB4 05",
                millDia: "5",
                shankDia: "8",
                flute: "10",
                oal: "100",
              },
              {
                itemCode: "PTNB4 06",
                millDia: "6",
                shankDia: "8",
                flute: "12",
                oal: "100",
              },
              {
                itemCode: "PTNB4 08",
                millDia: "8",
                shankDia: "10",
                flute: "14",
                oal: "100",
              },
            ],
          },
        ],
      },

      {
        title: "Stub Taper Neck Endmill : 2 / 4 Flutes",
        style: "stub",
        tables: [
          {
            subTitle: "Flat Endmills",
            headers: ["ITEM CODE", "MILL DIA", "SHANK DIA", "FLUTE", "OAL"],
            rows: [
              {
                itemCode: "PTNSE4 03",
                millDia: "3",
                shankDia: "6",
                flute: "6",
                oal: "50",
              },
              {
                itemCode: "PTNSE4 04",
                millDia: "4",
                shankDia: "6",
                flute: "8",
                oal: "50",
              },
              {
                itemCode: "PTNSE4 05",
                millDia: "5",
                shankDia: "8",
                flute: "10",
                oal: "75",
              },
              {
                itemCode: "PTNSE4 06",
                millDia: "6",
                shankDia: "8",
                flute: "12",
                oal: "75",
              },
              {
                itemCode: "PTNSE4 08",
                millDia: "8",
                shankDia: "10",
                flute: "14",
                oal: "75",
              },
            ],
          },
          {
            subTitle: "Ballnose",
            headers: ["ITEM CODE", "MILL DIA", "SHANK DIA", "FLUTE", "OAL"],
            rows: [
              {
                itemCode: "PTNSB4 03",
                millDia: "3",
                shankDia: "6",
                flute: "6",
                oal: "50",
              },
              {
                itemCode: "PTNSB4 04",
                millDia: "4",
                shankDia: "6",
                flute: "8",
                oal: "50",
              },
              {
                itemCode: "PTNSB4 05",
                millDia: "5",
                shankDia: "8",
                flute: "10",
                oal: "75",
              },
              {
                itemCode: "PTNSB4 06",
                millDia: "6",
                shankDia: "8",
                flute: "12",
                oal: "75",
              },
              {
                itemCode: "PTNSB4 08",
                millDia: "8",
                shankDia: "10",
                flute: "14",
                oal: "75",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 11,
    slug: "3 fulte & 6 fulte-endmill",
    category: "High-performance-endmills",
    name: "3 Fulte & 6 Fulte Endmill",

    images: {
      main: "/assets/images/pristine-product/Endmills-product-7.png",
      thumbs: ["/assets/images/pristine-product/Endmills-product-7.png", 
        "/assets/images/pristine-product/Endmill_Wire.png"],
    },

    tableGroups: [
      {
        title: "3 Flute Square Endmill",
        style: "three-flute",
        tables: [
          {
            headers: ["ITEM CODE", "MILL DIA", "SHANK DIA", "FLUTE", "OAL"],
            rows: [
              {
                itemCode: "PE3F 03R",
                millDia: "3",
                shankDia: "6",
                flute: "10",
                oal: "51",
              },
              {
                itemCode: "PE3F 04R",
                millDia: "4",
                shankDia: "6",
                flute: "14",
                oal: "51",
              },
              {
                itemCode: "PE3F 05R",
                millDia: "5",
                shankDia: "6",
                flute: "16",
                oal: "51",
              },
              {
                itemCode: "PE3F 06R",
                millDia: "6",
                shankDia: "6",
                flute: "19",
                oal: "51",
              },
              {
                itemCode: "PE3F 08R",
                millDia: "8",
                shankDia: "8",
                flute: "22",
                oal: "63",
              },
              {
                itemCode: "PE3F 10R",
                millDia: "10",
                shankDia: "10",
                flute: "30",
                oal: "70",
              },
              {
                itemCode: "PE3F 12R",
                millDia: "12",
                shankDia: "12",
                flute: "32",
                oal: "75",
              },
              {
                itemCode: "PE3F 14R",
                millDia: "14",
                shankDia: "14",
                flute: "30",
                oal: "80",
              },
              {
                itemCode: "PE3F 16R",
                millDia: "16",
                shankDia: "16",
                flute: "32",
                oal: "80",
              },
              {
                itemCode: "PE3F 18R",
                millDia: "18",
                shankDia: "18",
                flute: "35",
                oal: "101",
              },
              {
                itemCode: "PE3F 20R",
                millDia: "20",
                shankDia: "20",
                flute: "38",
                oal: "101",
              },
            ],
          },
        ],
      },

      {
        title: "6 Flute Square Endmill",
        style: "six-flute",
        tables: [
          {
            headers: ["ITEM CODE", "MILL DIA", "SHANK DIA", "FLUTE", "OAL"],
            rows: [
              {
                itemCode: "PE 6F 06R",
                millDia: "6",
                shankDia: "6",
                flute: "19",
                oal: "63",
              },
              {
                itemCode: "PE 6F 08R",
                millDia: "8",
                shankDia: "8",
                flute: "22",
                oal: "63",
              },
              {
                itemCode: "PE 6F 10R",
                millDia: "10",
                shankDia: "10",
                flute: "25",
                oal: "70",
              },
              {
                itemCode: "PE 6F 12R",
                millDia: "12",
                shankDia: "12",
                flute: "25",
                oal: "75",
              },
              {
                itemCode: "PE 6F 16R",
                millDia: "16",
                shankDia: "16",
                flute: "32",
                oal: "80",
              },
              {
                itemCode: "PE 6F 20R",
                millDia: "20",
                shankDia: "20",
                flute: "38",
                oal: "101",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 12,
    slug: "corner-redius-endmills",
    category: "High-performance-endmills",
    name: "Corner Redius Endmills",

    images: {
      main: "/assets/images/pristine-product/Corner_Radius_Endmill.png",
      thumbs: [
        "/assets/images/pristine-product/Corner_Radius_Endmill.png",
        "/assets/images/pristine-product/Corner_Radius_Wire.png",
      ],
    },

    table: [
      {
        itemCode: "PSL 06",
        cuttingDiameter: "6",
        shankDiameter: "6",
        fluteLength: "10",
        overallLength: "63",
      },
      {
        itemCode: "PSL 08",
        cuttingDiameter: "8",
        shankDiameter: "8",
        fluteLength: "12",
        overallLength: "63",
      },
      {
        itemCode: "PSL 10",
        cuttingDiameter: "10",
        shankDiameter: "10",
        fluteLength: "15",
        overallLength: "70",
      },
      {
        itemCode: "PSL 12",
        cuttingDiameter: "12",
        shankDiameter: "12",
        fluteLength: "20",
        overallLength: "75",
      },
      {
        itemCode: "PSL 14",
        cuttingDiameter: "14",
        shankDiameter: "14",
        fluteLength: "20",
        overallLength: "76",
      },
      {
        itemCode: "PSL 16",
        cuttingDiameter: "16",
        shankDiameter: "16",
        fluteLength: "25",
        overallLength: "76",
      },
      {
        itemCode: "PSL 20",
        cuttingDiameter: "20",
        shankDiameter: "20",
        fluteLength: "25",
        overallLength: "100",
      },
    ],
  },

  //Chamfer-Tools

  {
    id: 13,
    slug: "chamfer",
    category: "Chamfer-Tools",
    name: "Chamfer",

    images: {
      main: "/assets/images/pristine-product/champer-tools.png",
      thumbs: [
        "/assets/images/pristine-product/champer-tools.png",
        "/assets/images/pristine-product/Chamfer_Wire.png",
      ],
    },

    table: [
      {
        itemCode: "PCHF 03S",
        angle: "90°",
        cuttingDiameter: "3",
        shankDiameter: "4",
        fluteLength: "6",
        overallLength: "51",
      },
      {
        itemCode: "PCHF 04S",
        angle: "90°",
        cuttingDiameter: "4",
        shankDiameter: "4",
        fluteLength: "8",
        overallLength: "51",
      },
      {
        itemCode: "PCHF 05S",
        angle: "90°",
        cuttingDiameter: "5",
        shankDiameter: "6",
        fluteLength: "10",
        overallLength: "51",
      },
      {
        itemCode: "PCHF 06S",
        angle: "90°",
        cuttingDiameter: "6",
        shankDiameter: "6",
        fluteLength: "12",
        overallLength: "63",
      },
      {
        itemCode: "PCHF 08S",
        angle: "90°",
        cuttingDiameter: "8",
        shankDiameter: "8",
        fluteLength: "16",
        overallLength: "63",
      },
      {
        itemCode: "PCHF 10S",
        angle: "90°",
        cuttingDiameter: "10",
        shankDiameter: "10",
        fluteLength: "18",
        overallLength: "75",
      },
      {
        itemCode: "PCHF 12S",
        angle: "90°",
        cuttingDiameter: "12",
        shankDiameter: "12",
        fluteLength: "20",
        overallLength: "75",
      },
      {
        itemCode: "PCHF 14S",
        angle: "90°",
        cuttingDiameter: "14",
        shankDiameter: "14",
        fluteLength: "24",
        overallLength: "90",
      },
      {
        itemCode: "PCHF 16S",
        angle: "90°",
        cuttingDiameter: "16",
        shankDiameter: "16",
        fluteLength: "26",
        overallLength: "90",
      },
    ],
  },

  //Customized-Tools
  // {
  //   id: 13,
  //   slug: "customized-tools",
  //   category: "Customized-Tools",
  //   name: "Customized-Tools",

  //   images: {
  //     main: "/assets/images/pristine-product/customize-tools.png",
  //     thumbs: [
  //       "/assets/images/pristine-product/customize-tools.png",
  //       "/assets/images/productpart1.png",
  //     ],
  //   },

  // },

  {
    id: 14,
    slug: "customized-tools",
    category: "Customized-Tools",
    name: "Customized-Tools",

    images: {
      main: "/assets/images/pristine-product/customize-product-1.png",
      thumbs: [
        "/assets/images/pristine-product/customize-product-1.png",
        "/assets/images/productpart1.png",
      ],
    },
  },

  {
    id: 15,
    slug: "customized-tools",
    category: "Customized-Tools",
    name: "Customized-Tools",

    images: {
      main: "/assets/images/pristine-product/customize-product-2.png",
      thumbs: [
        "/assets/images/pristine-product/customize-product-2.png",
        "/assets/images/productpart1.png",
      ],
    },
  },

  {
    id: 16,
    slug: "customized-tools",
    category: "Customized-Tools",
    name: "Customized-Tools",

    images: {
      main: "/assets/images/pristine-product/customize-product-3.png",
      thumbs: [
        "/assets/images/pristine-product/customize-product-3.png",
        "/assets/images/productpart1.png",
      ],
    },
  },
  {
    id: 17,
    slug: "customized-tools",
    category: "Customized-Tools",
    name: "Customized-Tools",

    images: {
      main: "/assets/images/pristine-product/customize-product-4.png",
      thumbs: [
        "/assets/images/pristine-product/customize-product-4.png",
        "/assets/images/productpart1.png",
      ],
    },
  },
  //Ballnose-Endmills
  {
    id: 18,
    slug: "regular-ballnose-endmills",
    category: "Ballnose-Endmills",
    name: "Regular Ballnose Endmills",

    images: {
      main: "/assets/images/pristine-product/ballnose-tools.png",
      thumbs: [
        "/assets/images/pristine-product/ballnose-tools.png",
        "/assets/images/pristine-product/Ballnose_Wire.png",
      ],
    },

    table: [
      {
        itemCode: "PB4F 03 R",
        cuttingDiameter: "3",
        shankDiameter: "3",
        fluteLength: "10",
        overallLength: "39",
      },
      {
        itemCode: "PB4F 04 R",
        cuttingDiameter: "4",
        shankDiameter: "4",
        fluteLength: "14",
        overallLength: "51",
      },
      {
        itemCode: "PB4F 05 R",
        cuttingDiameter: "5",
        shankDiameter: "5",
        fluteLength: "16",
        overallLength: "51",
      },
      {
        itemCode: "PB4F 06 R",
        cuttingDiameter: "6",
        shankDiameter: "6",
        fluteLength: "19",
        overallLength: "63",
      },
      {
        itemCode: "PB4F 08 R",
        cuttingDiameter: "8",
        shankDiameter: "8",
        fluteLength: "22",
        overallLength: "63",
      },
      {
        itemCode: "PB4F 10 R",
        cuttingDiameter: "10",
        shankDiameter: "10",
        fluteLength: "25",
        overallLength: "70",
      },
      {
        itemCode: "PB4F 12 R",
        cuttingDiameter: "12",
        shankDiameter: "12",
        fluteLength: "25",
        overallLength: "75",
      },
      {
        itemCode: "PB4F 14 R",
        cuttingDiameter: "14",
        shankDiameter: "14",
        fluteLength: "30",
        overallLength: "80",
      },
      {
        itemCode: "PB4F 16 R",
        cuttingDiameter: "16",
        shankDiameter: "16",
        fluteLength: "32",
        overallLength: "89",
      },
      {
        itemCode: "PB4F 18 R",
        cuttingDiameter: "18",
        shankDiameter: "18",
        fluteLength: "35",
        overallLength: "100",
      },
      {
        itemCode: "PB4F 20 R",
        cuttingDiameter: "20",
        shankDiameter: "20",
        fluteLength: "38",
        overallLength: "100",
      },
    ],
  },
  {
    id: 19,
    slug: "long-ballnose-endmills",
    category: "Ballnose-Endmills",
    name: "Long Ballnose Endmills",

    images: {
      main: "/assets/images/pristine-product/ballnose-tools.png",
      thumbs: [
        "/assets/images/pristine-product/ballnose-tools.png",
        "/assets/images/pristine-product/Ballnose_Wire.png",
      ],
    },

    table: [
      {
        itemCode: "PB4F 03 L",
        cuttingDiameter: "3",
        shankDiameter: "3",
        fluteLength: "19",
        overallLength: "57",
      },
      {
        itemCode: "PB4F 04 L",
        cuttingDiameter: "4",
        shankDiameter: "4",
        fluteLength: "19",
        overallLength: "57",
      },
      {
        itemCode: "PB4F 05 L",
        cuttingDiameter: "5",
        shankDiameter: "5",
        fluteLength: "25",
        overallLength: "63",
      },
      {
        itemCode: "PB4F 06 L",
        cuttingDiameter: "6",
        shankDiameter: "6",
        fluteLength: "28",
        overallLength: "75",
      },
      {
        itemCode: "PB4F 08 L",
        cuttingDiameter: "8",
        shankDiameter: "8",
        fluteLength: "29",
        overallLength: "75",
      },
      {
        itemCode: "PB4F 10 L",
        cuttingDiameter: "10",
        shankDiameter: "10",
        fluteLength: "32",
        overallLength: "75",
      },
      {
        itemCode: "PB4F 12 L",
        cuttingDiameter: "12",
        shankDiameter: "12",
        fluteLength: "51",
        overallLength: "100",
      },
      {
        itemCode: "PB4F 14 L",
        cuttingDiameter: "14",
        shankDiameter: "14",
        fluteLength: "55",
        overallLength: "125",
      },
      {
        itemCode: "PB4F 16 L",
        cuttingDiameter: "16",
        shankDiameter: "16",
        fluteLength: "55",
        overallLength: "125",
      },
      {
        itemCode: "PB4F 18 L",
        cuttingDiameter: "18",
        shankDiameter: "18",
        fluteLength: "55",
        overallLength: "125",
      },
      {
        itemCode: "PB4F 20 L",
        cuttingDiameter: "20",
        shankDiameter: "20",
        fluteLength: "55",
        overallLength: "125",
      },
    ],
  },
  {
    id: 20,
    slug: "extra-long-ballnose-endmills",
    category: "Ballnose-Endmills",
    name: "Extra Long Ballnose Endmills",

    images: {
      main: "/assets/images/pristine-product/ballnose-tools.png",
      thumbs: [
        "/assets/images/pristine-product/ballnose-tools.png",
        "/assets/images/pristine-product/Ballnose_Wire.png",
      ],
    },

    table: [
      {
        itemCode: "PB4F 03 XL",
        cuttingDiameter: "3",
        shankDiameter: "3",
        fluteLength: "25",
        overallLength: "76",
      },
      {
        itemCode: "PB4F 04 XL",
        cuttingDiameter: "4",
        shankDiameter: "4",
        fluteLength: "25",
        overallLength: "76",
      },
      {
        itemCode: "PB4F 05 XL",
        cuttingDiameter: "5",
        shankDiameter: "5",
        fluteLength: "30",
        overallLength: "76",
      },
      {
        itemCode: "PB4F 06 XL",
        cuttingDiameter: "6",
        shankDiameter: "6",
        fluteLength: "39",
        overallLength: "101",
      },
      {
        itemCode: "PB4F 08 XL",
        cuttingDiameter: "8",
        shankDiameter: "8",
        fluteLength: "42",
        overallLength: "101",
      },
      {
        itemCode: "PB4F 10 XL",
        cuttingDiameter: "10",
        shankDiameter: "10",
        fluteLength: "45",
        overallLength: "101",
      },
      {
        itemCode: "PB4F 12 XL",
        cuttingDiameter: "12",
        shankDiameter: "12",
        fluteLength: "76",
        overallLength: "150",
      },
      {
        itemCode: "PB4F 14 XL",
        cuttingDiameter: "14",
        shankDiameter: "14",
        fluteLength: "76",
        overallLength: "150",
      },
      {
        itemCode: "PB4F 16 XL",
        cuttingDiameter: "16",
        shankDiameter: "16",
        fluteLength: "76",
        overallLength: "150",
      },
      {
        itemCode: "PB4F 18 XL",
        cuttingDiameter: "18",
        shankDiameter: "18",
        fluteLength: "76",
        overallLength: "150",
      },
      {
        itemCode: "PB4F 20 XL",
        cuttingDiameter: "20",
        shankDiameter: "20",
        fluteLength: "76",
        overallLength: "150",
      },
    ],
  },
  //reamer
  {
    id: 21,
    slug: "reamer",
    category: "Reamer",
    name: "Reamer",

    images: {
      main: "/assets/images/pristine-product/reamer.png",
      thumbs: [
        "/assets/images/pristine-product/reamer.png",
        "/assets/images/pristine-product/Reamer_Wire.png",
      ],
    },

    table: [
      {
        itemCode: "PR4 03",
        cuttingDiameter: "3",
        shankDiameter: "6",
        fluteLength: "15",
        overallLength: "60",
      },
      {
        itemCode: "PR4 04",
        cuttingDiameter: "4",
        shankDiameter: "6",
        fluteLength: "18",
        overallLength: "60",
      },
      {
        itemCode: "PR4 05",
        cuttingDiameter: "5",
        shankDiameter: "6",
        fluteLength: "20",
        overallLength: "60",
      },
      {
        itemCode: "PR4 06",
        cuttingDiameter: "6",
        shankDiameter: "6",
        fluteLength: "25",
        overallLength: "75",
      },
      {
        itemCode: "PR6 08",
        cuttingDiameter: "8",
        shankDiameter: "8",
        fluteLength: "30",
        overallLength: "76",
      },
      {
        itemCode: "PR6 10",
        cuttingDiameter: "10",
        shankDiameter: "10",
        fluteLength: "35",
        overallLength: "100",
      },
      {
        itemCode: "PR6 12",
        cuttingDiameter: "12",
        shankDiameter: "12",
        fluteLength: "40",
        overallLength: "100",
      },
    ],
  },

  // 👉 add more products same way
];

export default productsData;
